import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Home7TageBodyBoost from './pages/Home7TageBodyBoost';
import ThankYou from './pages/ThankYou';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Checkout from './pages/Checkout';
import Artikel from './pages/Artikel';
import ArtikelBodyBoost from './pages/ArtikelBodyBoost';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/7-tage-body-boost" element={<Home />} />
          <Route path="/7-tage-boody-boost" element={<Home />} />
          <Route path="/7tageBodyBoost" element={<Home7TageBodyBoost />} />
          <Route path="/7-tage-boody-boost/los-gehts" element={<ThankYou />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/artikel/7tage-report" element={<Artikel />} />
          <Route path="/artikel/Bodyboost" element={<ArtikelBodyBoost />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
